import * as types from './types';

const initialState = {
  features: {},
  featuresOriginal: {},
  featureCategories: [],
  textInputsValues: {}
};

const textInputDefaults = {};

function step3Module1Reducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_FEATURES_COMPLETED:
      action.payload.featureInputs.map(f => {
        if (f.value === null) {
          f.value = '';
        }
        textInputDefaults[f.id] = f.value;
        return f;
      });
      action.payload.featureSelect.map(f => {
        if (f.value === null) {
          f.value = '';
        }
        return f;
      });
      return {
        ...state,
        features: action.payload,
        featuresOriginal: JSON.parse(JSON.stringify(action.payload)),
        featureCategories: action.payload.featureChecks.reduce((finalArray, feature) => {
          if (
            feature.categoryName &&
            feature.categoryId &&
            !finalArray.some(c => c.categoryName === feature.categoryName)
          ) {
            finalArray.push({
              categoryId: feature.categoryId,
              categoryName: feature.categoryName,
              openDrop: false
            });
          }
          return finalArray;
        }, []),
        textInputsValues: textInputDefaults
      };
    case types.GET_FEATURES_FAILED:
      return {
        ...state,
        featuresError: true
      };
    case types.CHECK_FEATURE:
      return {
        ...state,
        features: {
          ...state.features,
          featureChecks: state.features.featureChecks.map(f => {
            if (f.id === action.payload) {
              f.isChecked = !f.isChecked;
              f.touched = true;
            }
            return f;
          })
        }
      };
    case types.CHANGE_INPUT:
      return {
        ...state,
        features: {
          ...state.features,
          [action.payload.inputType]: state.features[action.payload.inputType].map(f => {
            if (f.id === action.payload.inputId) {
              f.value = action.payload.value;
              f.touched = true;
            }
            return f;
          })
        }
      };
    default:
      return state;
  }
}

export { step3Module1Reducer };
